import React from 'react';
import { Trans } from 'react-i18next';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type Props = {
  children: React.ReactNode;
};

type State = {
  error: any;
};

class ChunkLoadErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: any) {
    return { error };
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      if (error instanceof Error && error.name === 'ChunkLoadError') {
        return (
          <Dialog aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" open>
            <DialogTitle id="alert-dialog-title" data-testid="alert-dialog-title">
              <Trans i18nKey="chunk_load_alert.title" />
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" data-testid="alert-dialog-description">
                <Trans i18nKey="chunk_load_alert.description" />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                onClick={() => window.location.reload()}
                autoFocus
                data-testid="alert-dialog-action"
              >
                <Trans i18nKey="chunk_load_alert.action" />
              </Button>
            </DialogActions>
          </Dialog>
        );
      }

      throw error;
    }

    return children;
  }
}

export default ChunkLoadErrorBoundary;
